import React from 'react';
import { Heart, Package, UserRound } from 'lucide-react';
import ActionList from '@ajat/design-system/ActionList';
import { ComponentPage, DemoCard } from '../../shared';

export const meta = {
  component: ActionList,
  componentName: 'ActionList',
  title: 'Action List',
  group: 'Data display',
  importPath: '@ajat/design-system/ActionList',
  description:
    'Full-width rows between hairlines — each a DS Hyperlink (large) with a leading icon, the label, an optional CountBadge and a trailing arrow. The "Mitt konto" hub, a help centre\'s topics, a drawer\'s sections.',
  props: [
    ['items', 'array', '—', '[{ id, icon, label, count, href, onClick }]'],
    ['dividers', 'bool', 'true', 'Hairlines above and between the rows'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'Account hub',
      code: `import ActionList from '@ajat/design-system/ActionList';

<ActionList items={[
  { id: 'saved', icon: <Heart size={20} />, label: 'Sparade designer', count: 4, onClick: openSaved },
  { id: 'orders', icon: <Package size={20} />, label: 'Mina ordrar', count: 2, onClick: openOrders },
  { id: 'profile', icon: <UserRound size={20} />, label: 'Mina uppgifter', onClick: openProfile },
]} />`,
    },
  ],
};

export default function ActionListPage() {
  const stop = (e) => e.preventDefault();
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Account hub">
        <div style={{ maxWidth: 420 }}>
          <ActionList
            items={[
              { id: 'saved', icon: <Heart size={20} />, label: 'Sparade designer', count: 4, onClick: stop },
              { id: 'orders', icon: <Package size={20} />, label: 'Mina ordrar', count: 2, onClick: stop },
              { id: 'profile', icon: <UserRound size={20} />, label: 'Mina uppgifter', onClick: stop },
            ]}
          />
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
